module.exports = __webpack_public_path__ + "media/images/landkit/icons/payment-methods/maestro-old-7c99df33ad1b44415b76746b4fa88443.svg";